import Modal from "react-modal";
import React from "react";
import "./Factor.css";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { logoutUser } from "../../services/auth";

export default function LogOut({
  changeModalStatus = false,
  setChangeModalStatus,
}) {
  const [modalIsOpen, setModalIsOpen] = useState(changeModalStatus);
  const isSmall = useMediaQuery({ query: "(max-width: 768px)" });
  const navigate = useNavigate();

  const customStylesDesktop = {
    overlay: {
      position: "fixed",
      zIndex: 1020,
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0, 0.5)",
      display: "flex",
      justifyContent: "center",
    },

    content: {
      background: "#ffffff",
      width: "421px",
      maxWidth: "calc(150vw - 2rem)",
      maxHeight: "297px",
      border: "0px",
      overflowY: "auto",
      position: "relative",
      borderRadius: "0.8rem",
      inset: "9px",
    },
  };

  const customStylesMobile = {
    overlay: {
      position: "fixed",
      zIndex: 1020,
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0, 0.5)",
      display: "flex",
      justifyContent: "center",
    },

    content: {
      background: "#ffffff",
      width: "34rem",
      maxWidth: "calc(150vw - 2rem)",
      maxHeight: "calc(95vh - 1rem)",
      overflowY: "auto",
      border: "0px",
      position: "relative",
      borderRadius: "0.4rem",
      inset: "0px",
      margin: "0vh 0px 0px 0px",
    },
  };

  Modal.setAppElement("#root");

  function closeModal() {
    setModalIsOpen(false);
    setChangeModalStatus(false);
  }

  function handleSubmit() {
    logoutUser().then((data) => {
      if (data.status === 200 || data.status === 201) {
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("refresh");
        navigate("/");
        toast.success("با موفقیت خارج شدید!");
      }
    });
  }

  useEffect(() => {
    setModalIsOpen(changeModalStatus);
    setChangeModalStatus(changeModalStatus);
  }, [changeModalStatus]);
  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        ariaHideApp={false}
        style={isSmall ? customStylesMobile : customStylesDesktop}
        contentLabel="Example Modal"
        backdrop="static"
      >
        <div className={"container"} id={"mbody"}>
          <div>خروج از حساب کاربری</div>

          <div className="dkjjashdtetxzxz2242421">
            تصمیم داری از حساب کاربریت خارج بشی؟
          </div>

          <div className="displayff">
            <button
              className="btn  text-white btn-6464 mydoubtn1 cance2421btn"
              onClick={closeModal}
            >
              منصرف شدم
            </button>

            <button
              type="button"
              className="btn btn-gold text-white btn-6464 mydoubtn2 btn-logout"
              onClick={handleSubmit}
            >
              خارج میشم
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}
